import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityType } from '@vendasta/automata';
import { Observable } from 'rxjs';
import {
  getPluralEntityTypeDisplayTranslationString,
  getSingularEntityTypeDisplayTranslationString,
  getSingularEntityTypeWithArticleDisplayTranslationString,
} from './entities';

@Pipe({
  standalone: true,
  name: 'entity',
})
export class EntityPipe implements PipeTransform {
  constructor(private readonly translate: TranslateService) {}
  transform(value: EntityType, anPrefix?: boolean, singular?: boolean): Observable<string> {
    if (anPrefix) {
      return this.translate.stream(getSingularEntityTypeWithArticleDisplayTranslationString(value));
    }

    if (singular) {
      return this.translate.stream(getSingularEntityTypeDisplayTranslationString(value));
    }

    return this.translate.stream(getPluralEntityTypeDisplayTranslationString(value));
  }
}
